module.exports = __webpack_public_path__ + "static/media/header-logo.ae76e3ea.png";